import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_planpicker_save_w_checkout_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_planpicker_save_w_checkout_update/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_planpicker_save_w_checkout_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_planpicker_save_w_checkout_update/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_planpicker_save_w_checkout_update~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_planpicker_save_w_checkout_update/__b'),
			},
		},
	},
]

export default config
